import * as React from 'react'

import { cn } from 'src/lib/utils'

import { Spinner } from './Spinner'

interface LoadingRegionProps extends React.ComponentProps<'div'> {
  description?: string
}

export const LoadingRegion = React.forwardRef<
  HTMLDivElement,
  LoadingRegionProps
>(({ className, description, ...props }, ref) => {
  return (
    <div
      ref={ref}
      role="status"
      data-testid="area-loader"
      className={cn(
        'flex h-full min-h-32 w-full flex-col items-center justify-center gap-ds-8 text-body-14 text-ds-text-subtle',
        className
      )}
      {...props}
    >
      <div className="gap-ds-8 flex items-center">
        <Spinner aria-hidden="true" className="size-ds-icon-xl" />
        Loading...
      </div>
      {description && <span>{description}</span>}
    </div>
  )
})
LoadingRegion.displayName = 'LoadingRegion'
